// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"706":"a5caeae0","741":"a5caeae0","783":"164b6cd1","3888":"a5caeae0","6154":"7cff2fcf","7015":"a1a811f2"}[chunkId] + ".chunk.css";
};